import { Component } from '@angular/core';
import { SUPPORT_EMAIL } from '../../../../app.constants';

@Component({
  selector: 'app-terms',
  templateUrl: './terms.page.html',
  styleUrl: '../legal.page.scss'
})
export class TermsPage {
  readonly supportEmail = SUPPORT_EMAIL;
}
